import { PartitionOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
import styles from "./ReceiptMultiInvoiceAllocation.module.scss";

const { Title, Text } = Typography;

export const HeaderSection: React.FC = () => (
  <div className={styles.header}>
    <div className={styles.headerTitleRow}>
      {/* <PartitionOutlined className={styles.headerIcon} /> */}
      <Title level={5} className={styles.headerTitle}>
        Receipt &amp; Invoice Allocation
      </Title>
    </div>
    <Text className={styles.headerSubtitle}>
      Enter the total amount to receive, then distribute it across selected invoices.
    </Text>
  </div>
);
